import { GlobalBase } from './global-base.js';
export class DbqInlineQuestions extends GlobalBase {
  static get is() {
    return 'dbq-inline-questions';
  }

  static get properties() {
    return {
      essayEndPoint: String,
      autoSaveStatus: Object,
      timer: Object,
      isEssayBuilder: Boolean,
      prevSave: Object,
      isInstructorFeedbackMode: Boolean,
      readonly: Boolean,
      hasLegacySave: {
        type: Boolean,
        value: true
      }
    };
  }

  ready() {
    super.ready();

    requestAnimationFrame(() => {
      this.initialize();
      if (this.readonly) {
        this.querySelectorAll('input, textarea, select').forEach((el) => {
          el.disabled = true;
        });
      }
    });
  }

  loadAnswers() {
    var options = {
      page: this.page,
      asgn: this.asgn
    };

    if (this.isInstructorFeedbackMode) {
      options.studentId = this.studentId;
    }

    return this.postEndpoint(this.essayEndPoint, options).then((data) => {

      if (data.questions) {
        for (var i = 0; i < data.questions.length; i++) {
          if (data.questions[i].answerId !== '') {

            var answerEl = this.querySelector('#' + data.questions[i].answerId);
            if (answerEl) {
              if (!answerEl.classList.contains('essay')) {
                answerEl.value = data.questions[i].answerText;
              }
            }
          }
        }
      }

      var isNotInModal = this.isModal ? false : true,
          isNotInstructorFeedbackMode = !this.isInstructorFeedbackMode,
        isNotAssignmentAnnotations = !this.isAssignmentAnnotations;
      if (isNotInModal && isNotInstructorFeedbackMode && this.hasLegacySave) {
          this.autoSaveStatus = window.AutoSaveIndicator.create();
      }

      if (this.autoSaveStatus) {
        setTimeout(() => {
          this.autoSaveStatus.setLoaded();
        }, 500);
      }
      this.attachListeners();

      if (
        this.readonly ||
        this.isModal ||
        this.isInstructorFeedbackMode ||
        this.isAssignmentAnnotations
      ) {
        this.querySelectorAll('.answer, .paragraph').forEach((el) => {
          el.disabled = true;
        });
      }
      return data;
    });
  }

  getEssay() {
    var questions = this.querySelectorAll('.questions'),
      answers = this.querySelectorAll('.answer');
    if (questions) {
      return this.essayObj(questions, answers);
    } else {
      return false;
    }
  }

  essayObj(questions, answers) {
    var essayObj = {
      page: this.page,
      asgn: this.asgn,
      questions: []
    };
    for (var i = 0; i < questions.length; i++) {
      essayObj.questions.push({
        questionId: questions[i].id,
        questionText: questions[i].innerHTML,
        answerId: answers[i] ? answers[i].id : '',
        answerText: answers[i] ? answers[i].value : '',
        submitted: false
      });
    }
    return essayObj;
  }

  onKeyUp() {
    if (this.readonly) {
      return;
    }
    window.onbeforeunload = (e) => {
      var dialogText =
        this.trans('general.beforeUnload')
      e.returnValue = dialogText;
      return dialogText;
    };

    if (this.timer !== null) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.saveEssay();
    }, 3000);
  }

  attachListeners() {
    var answers = this.querySelectorAll('.answer');
    answers.forEach((el) => {
      el.addEventListener('keypress', () => {
        this.onKeyUp();
      });
      el.addEventListener('focusout', () => {
        this.saveEssay();
      });
    });
  }

  saveEssay() {
    if (this.readonly) {
      return;
    }
    var essay = this.getEssay();
    if (this.prevSave !== undefined && this.prevSave === essay) {
      return;
    }
    if (this.autoSaveStatus) {
      this.autoSaveStatus.setSaving();
    }
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }

    return this.postEndpoint('/overlay/save_essay/', essay).then((data) => {
      this.prevSave = essay;
      this.handleResponse(data);
      window.onbeforeunload = undefined;
      return data;
    });
  }

  handleResponse(data) {
    setTimeout(() => {
      if (!this.autoSaveStatus) {
        return;
      }
      if (data.success) {
        this.autoSaveStatus.setSaved();
      } else {
        this.autoSaveStatus.setError();
      }
    }, 1000);
  }

  initialize() {
    if (this.asgn !== undefined && this.asgn !== '' && this.page !== undefined) {
      if (this.isInstructorFeedbackMode) {
        this.essayEndPoint = '/overlay/feedback/student/essay/get/';
      } else {
        this.essayEndPoint = '/overlay/essay/';
      }
      this.loadAnswers();
    }
  }
}
customElements.define(DbqInlineQuestions.is, DbqInlineQuestions);
